import { Field, Form } from 'react-final-form';
import { required } from '../../helpers';
import { useChangePassword } from '../../hooks/account_settings/useChangePassword';
import FormError from '../Common/FormError';
import LoadingIndicator from '../Common/LoadingIndicator';

const ChangePassword = () => {
  const { submitting, handleChangePassword } = useChangePassword()

  return (
    <Form
      onSubmit={handleChangePassword}
      render={({ handleSubmit, invalid }) => (
        <form onSubmit={handleSubmit}>
          <div className="mb-5 col-lg-12">
            <Field name="password" validate={(v) => required(v, "Current-password")}>
              {({ input, meta }) => (
                <>
                  <label className="form-label">Current Password</label>
                  <div className="mb-3">
                    <input
                      type="password"
                      {...input}
                      className="form-control form-control-lg form-control-solid"
                    />
                    <FormError meta={meta} />
                  </div>
                </>
              )}
            </Field>
          </div>

          <div className="mb-5 col-lg-12">
            <Field name="new_password" validate={(v) => required(v, "New-password")}>
              {({ input, meta }) => (
                <>
                  <label className="form-label">New Password</label>
                  <div className="mb-3">
                    <input
                      type="password"
                      {...input}
                      className="form-control form-control-lg form-control-solid"
                    />
                    <FormError meta={meta} />
                  </div>
                </>
              )}
            </Field>
          </div>

          <div className="mb-5 col-lg-12">
            <Field name="confirm_password" validate={(v) => required(v, "Confirm-password")}>
              {({ input, meta }) => (
                <>
                  <label className="form-label">Confirm Password</label>
                  <div className="mb-3">
                    <input
                      type="password"
                      {...input}
                      className="form-control form-control-lg form-control-solid"
                    />
                    <FormError meta={meta} />
                  </div>
                </>
              )}
            </Field>
          </div>

          <div className="text-lg-end">
            <button type="submit" className="btn btn-success" disabled={invalid}>
              {submitting ? <LoadingIndicator /> : "Save Changes"}
            </button>
          </div>
        </form>
      )}
    />
  );
};

export default ChangePassword;
